module.exports = __webpack_public_path__ + "static/media/hhw.cf91f290.svg";